<template>
  <div class="file-preview">
    <button
      title="Удалить файл"
      class="file-preview__control"
      @click="$emit('clear')"
    >
      <BaseIcon glyph="close" width="10px" />
    </button>
    <slot :name="file" :size="fileSize">
      <div v-if="file" :title="fileName" class="file-preview__name">
        <span class="file-preview__title">{{ fileName }}</span>
        <span class="file-preview__size">{{ fileSize }}</span>
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  name: "FilePreview",
  props: {
    file: {},
  },
  computed: {
    fileName() {
      const { file } = this;
      if (file) {
        const name = Array.from(file).map((file) => file.name);
        return name.join(", ");
      }
      return "";
    },
    fileSize() {
      const { file } = this;
      const size = Array.from(file).reduce((acc, value) => {
        return (acc += value.size);
      }, 0);
      if (size) {
        return (size * 0.000001).toFixed(3) + " MB";
      }
      return 0;
    },
  },
};
</script>

<style lang="less" scoped>
.file-preview {
  height: @input-height;
  border: @input-border-width dashed @input-focus-border-color;
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  border-radius: @input-border-radius;
  padding: 0px @input-padding;
  max-width: 100%;

  &__control {
    flex-grow: 0;
    border: 1px solid @dark-gray-color;
    color: @dark-gray-color;
    box-shadow: none;
    background: transparent;
    padding: 1px 4px;
    border-radius: @border-radius-xs;
    margin-right: 8px;
    outline: none;

    &:hover {
      border-color: @primary-color;
      background-color: @primary-color;
      color: #fff;
      cursor: pointer;
    }
  }

  &__name {
    display: inline-flex;
    flex-grow: 1;
    max-width: 80%;
    color: @primary-color;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
  }

  &__size {
    flex: 0 0 auto;
    white-space: nowrap;
    margin-left: 0.2em;
  }

  &__title {
    flex: 1 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    white-space: nowrap;
    max-width: 100%;
  }
}
</style>
